import React from 'react';
import { motion } from 'framer-motion';
export function Urgency() {
  return <section className="bg-red-50 border-y border-red-100 py-8" data-id="element-230">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left" data-id="element-232">
          <div className="bg-red-100 text-red-600 p-3 rounded-full flex-shrink-0" data-id="element-233">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-234">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-235"></path>
            </svg>
          </div>
          <div data-id="element-236">
            <p className="text-red-800 font-bold text-lg mb-1" data-id="element-237">
              Este es un lanzamiento inicial.
            </p>
            <p className="text-red-700" data-id="element-238">
              El precio actual es promocional y puede cambiar sin aviso.
            </p>
            <p className="text-red-900 font-semibold mt-2" data-id="element-239">
              👉 Si estás viendo esto ahora, aprovechalo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}